import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
	rtl: true,
	theme: {
		options: { customProperties: true },
		themes: {
			light: {
				primary: '#2d8b8b',
				secondary: '#3aa6a6',
				accent: '#3aa6a6',
				info: '#3aa6a6',
				success: '#10b981',
				warning: '#f59e0b',
				error: '#ef4d6a',
				anchor: '#2d8b8b',
			},
		},
	},
});
